import { useEffect, useState } from "react";
import { useAppBridge } from "@shopify/app-bridge-react";
import { getSessionToken } from "@shopify/app-bridge-utils";
import { Redirect } from "@shopify/app-bridge/actions";

export default function useInstallBackend(onComplete) {
  const app = useAppBridge();
  const [installComplete, setInstallComplete] = useState(false);

  useEffect(() => {
    // Wait for App Bridge to be fully ready
    if (!app) return;

    const params = new URLSearchParams(window.location.search);
    const shop = params.get("shop");
    const isNewInstall = params.get("isNewInstall") === "1";

    if (!isNewInstall) {
      setInstallComplete(true);
      if (onComplete) onComplete();
      return;
    }

        //  Helper to clean URL using App Bridge
    // const cleanUrl = () => {
    //   const cleanParams = new URLSearchParams(window.location.search);
    //   cleanParams.delete("isNewInstall");
    //   const redirect = Redirect.create(app);
    //   redirect.dispatch(
    //     Redirect.Action.APP,
    //     `/?${cleanParams.toString()}`
    //   );
    // };
//     const cleanUrl = () => {
//   const cleanParams = new URLSearchParams(window.location.search);
//   cleanParams.delete("isNewInstall");

//   const redirect = Redirect.create(app);
//   const queryString = cleanParams.toString();

//   redirect.dispatch(
//     Redirect.Action.APP,
//     queryString ? `?${queryString}` : ""  // ← No leading slash
//   );
// };

// const cleanUrl = () => {
//   const cleanParams = new URLSearchParams(window.location.search);
//   cleanParams.delete("isNewInstall"); // remove the param

//   const redirect = Redirect.create(app);
//   const queryString = cleanParams.toString();

//   redirect.dispatch(
//     Redirect.Action.APP,
//     queryString ? `?${queryString}` : ""  // if no other params remain, dispatch ""
//   );
// };  


    const installApp = async () => {
      try {
        if (!shop) {
          console.error("No shop param in URL");
          setInstallComplete(true);
          if (onComplete) onComplete();
          return;
        }

        try{
          const res1 = await fetch(`/api/shopifyInstalledStatus/${shop}`, {
            method: "GET",
          });
          if(res1.ok){
            const payload = await res1.json();
            const status = payload?.data?.data?.isInstalled;
            console.log(status)
            if(status){
              setInstallComplete(true);
              if (onComplete) onComplete();
              return;
            }
          }
        }catch(e){
          console.warn("Shop credits error:", e.message);
        }

        const token = await getSessionToken(app);

        let shopEmail = "";
        let shopOwner = "Unknown";

        try {
          const shopRes = await fetch(`/api/shopifyDetail/${encodeURIComponent(shop)}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          if (shopRes.ok) {
            const shopData = await shopRes.json();
            shopEmail = shopData.shopEmail || "";
            shopOwner = shopData.shopOwner || "Unknown";
          } else {
            console.warn("Shop details fetch failed:", shopRes.status);
          }
        } catch (shopErr) {
          console.warn("Shop details error:", shopErr.message);
        }

        
        const payload = {
          sessionToken: token,
          targetStoreDomain: shop,
          emailId: shopEmail,
          userName: shopOwner,
        };
        const res = await fetch("/api/shopifyInstall", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        const data = await res.json().catch(() => ({}));

        if (res.ok) {

          // Clean up the URL parameter seamlessly so refreshing doesn't re-trigger an installation
          // if (typeof window !== "undefined" && window.history.replaceState) {
          //   const cleanUrl = new URL(window.location.href);
          //   cleanUrl.searchParams.delete("isNewInstall");
          //   window.history.replaceState({ path: cleanUrl.href }, "", cleanUrl.href);
          // }

          setInstallComplete(true);
          // cleanUrl();
          if (onComplete) onComplete();
        } else {
          console.warn("Backend failed:", data.error);
          // cleanUrl();
          // Added Eject Logic
          if (data.triggerEject) {

            const shopNameFromDomain = shop.split(".")[0];
            const escapeUrl = `https://admin.shopify.com/store/${shopNameFromDomain}/settings/apps`;

            if (window.top !== window.self) {
              window.top.location.href = escapeUrl;
            } else {
              window.location.href = escapeUrl;
            }

            return;
          }

          // Fallback completion if it failed but didn't trigger an eject
          setInstallComplete(true);
          // cleanUrl();
          if (onComplete) onComplete();
        }
      } catch (err) {
        setInstallComplete(true);
        // cleanUrl();
        if (onComplete) onComplete();
      }
    };

    installApp();
  }, [app, onComplete]);

  return { installComplete };
}